export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14935.a14052b8.jpg";